import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import LoginForm from '../components/auth/LoginForm';
import SignUpForm from '../components/auth/SignUpForm';

const HybridAuthModal = () => {
  const { authModal, closeAuthModal, openAuthModal } = useAuth();

  const handleClose = () => {
    closeAuthModal();
  };

  const handleAuthSuccess = () => {
    console.log('✅ Authentication successful in modal');
    closeAuthModal();
  };

  const handleSwitchMode = () => {
    // Toggle between login and signup modes
    const newMode = authModal.mode === 'login' ? 'signup' : 'login';
    closeAuthModal();
    // Use a small delay to ensure clean transition
    setTimeout(() => {
      openAuthModal(newMode, { role: authModal.preSelectedRole });
    }, 50);
  };

  if (authModal.mode === 'login') {
    return (
      <LoginForm
        open={authModal.open}
        onClose={handleClose}
        onSuccess={handleAuthSuccess}
        onSwitchToSignUp={handleSwitchMode}
      />
    );
  }

  return (
    <SignUpForm
      open={authModal.open}
      onClose={handleClose}
      onSuccess={handleAuthSuccess}
      onSwitchToLogin={handleSwitchMode}
      preSelectedRole={authModal.preSelectedRole}
    />
  );
};

export default HybridAuthModal;